// Sales Order Results ID Schemas
import { EntityIdSchema } from "@repo/core/universal";
import { SerializableSchema, z } from "@repo/utils";

export const DeliveryTypeSchema = z.enum(["DELIVERY", "PICKUP"]);
export const WorkflowIdSchema = EntityIdSchema("wkf");
export const TransactionIdSchema = EntityIdSchema("tra");
export const PositionIdSchema = EntityIdSchema("pos");
export const PositionMatchIdSchema = EntityIdSchema("pma");
export const SuggestedPositionMatchSchema = z.object({
    id: PositionMatchIdSchema,
    invalidated: z.boolean(),
    productId: z.string(),
    product: SerializableSchema,
    quantity: z.number(),
    validQuantity: z.number(),
    quantityUnitId: z.string(),
    quantityUnitCode: z.string(),
    price: z._default(z.nullish(z.number()), null),
    priceUnitId: z._default(z.nullish(z.string()), null),
    priceUnitCode: z._default(z.nullish(z.string()), null),
    priceQuantity: z._default(z.nullish(z.number()), null),
    matchingWarning: z._default(z.boolean(), false),
    matchingExplanation: z._default(z.nullish(z.string()), null),
    customFields: z.nullish(z.record(z.string(), SerializableSchema)),
});
export const SuggestedPositionSchema = z.object({
    id: PositionIdSchema,
    invalidated: z.boolean(),
    positionIndex: z.number(),
    extractedPositionIndex: z._default(z.nullish(z.string()), null),
    deliveryDate: z._default(z.nullish(z.string()), null),
    extractedDeliveryDate: z._default(z.nullish(z.string()), null),
    extractedArticleNumbers: z._default(z.nullish(z.array(z.string())), null),
    extractedDescription: z.string(),
    extractedQuantity1: z.number(),
    extractedQuantityUnit1: z.string(),
    extractedQuantity2: z._default(z.nullish(z.number()), null),
    extractedQuantityUnit2: z._default(z.nullish(z.string()), null),
    extractedQuantity3: z._default(z.nullish(z.number()), null),
    extractedQuantityUnit3: z._default(z.nullish(z.string()), null),
    extractedPrice1: z._default(z.nullish(z.number()), null),
    extractedPriceUnit1: z._default(z.nullish(z.string()), null),
    extractedPriceQuantity1: z._default(z.nullish(z.number()), null),
    extractedPrice2: z._default(z.nullish(z.number()), null),
    extractedPriceUnit2: z._default(z.nullish(z.string()), null),
    extractedPriceQuantity2: z._default(z.nullish(z.number()), null),
    extractedPrice3: z._default(z.nullish(z.number()), null),
    extractedPriceUnit3: z._default(z.nullish(z.string()), null),
    extractedPriceQuantity3: z._default(z.nullish(z.number()), null),
    extractedTotalValue: z._default(z.nullish(z.number()), null),
    customFields: z.nullish(z.record(z.string(), SerializableSchema)),
    matches: z.array(SuggestedPositionMatchSchema),
});
export const SuggestedTransactionSchema = z.object({
    id: TransactionIdSchema,
    relevantMessageIds: z._default(z.array(z.string()), []),
    relevantAttachmentIds: z._default(z.array(z.string()), []),
    customerAccountIds: z._default(z.array(z.string()), []),
    billToPartyIds: z._default(z.array(z.string()), []),
    shipToPartyIds: z._default(z.array(z.string()), []),
    newBilledPartyAddress: z._default(z.nullish(SerializableSchema), null),
    newPayingPartyAddress: z._default(z.nullish(SerializableSchema), null),
    newShipToAddress: z._default(z.nullish(SerializableSchema), null),
    sellingEntityId: z._default(z.nullish(z.string()), null),
    sellingEntityAddressId: z._default(z.nullish(z.string()), null),
    receivedDate: z.string(),
    emailReceivedDate: z._default(z.nullish(z.string()), null),
    orderDate: z.string(),
    deliveryType: z._default(z.nullish(DeliveryTypeSchema), null),
    contactId: z._default(z.nullish(z.string()), null),
    contactName: z.string(),
    contactEmail: z.string(),
    contactPhone: z._default(z.nullish(z.string()), null),
    originalOrderReference: z._default(z.nullish(z.string()), null),
    orderReference: z._default(z.nullish(z.string()), null),
    quoteNumber: z._default(z.nullish(z.string()), null),
    transactionType: z.string(),
    eligibleOrderSplitStrategy: z._default(z.nullish(z.string()), null),
    appliedOrderSplitStrategy: z._default(z.nullish(z.string()), null),
    currencyId: z.string(),
    currencyCode: z.string(),
    customFields: z.nullish(z.record(z.string(), SerializableSchema)),
    positions: z.array(SuggestedPositionSchema),
    invalidated: z.boolean(),
    autoSubmitResult: z._default(z.nullish(z.enum(["SUCCESS", "FAILURE"])), null),
    autoSubmitError: z._default(z.nullish(z.string()), null),
    autoSubmittedAt: z._default(z.nullish(z.string()), null),
});
export const SalesOrderWorkflowResultSchema = z.object({
    transactions: z.array(SuggestedTransactionSchema),
});
